import React from "react";
import { useFormikContext } from "formik";

import Typography from "ui/Typography";
import IconButton from "ui/IconButton";

import DarkIcon from "assets/svg/dark.svg";
import LightIcon from "assets/svg/heat.svg";

import { DARK, LIGHT } from "constants/appModes";

const Header = () => {
  const {
    values: { mode },
    setFieldValue,
  } = useFormikContext();

  const onSwitchMode = () => {
    const nextMode = mode === DARK ? LIGHT : DARK;
    setFieldValue("mode", nextMode, true).then();
  };

  return (
    <div className="theme-builder-l-header">
      <div className="theme-builder-header-text-container">
        <Typography variant="h5">Logo & Theme generator</Typography>
        <Typography variant="body1" color="surface.onSurfaceVariant">
          Instantly create stunning color schemes by entering a primary color or
          creating a gradient.
        </Typography>
      </div>
      <IconButton id="switch-theme-mode" size="20px" onClick={onSwitchMode}>
        {mode === DARK ? <LightIcon /> : <DarkIcon />}
      </IconButton>
    </div>
  );
};

export default Header;
